import React, { useEffect, useState } from 'react';
import { downloadJsonAsExcel } from '../utils/excel';

/**
 * @file
 * @module Pages/BounceTable
 * @description BounceTable est une page qui affiche un tableau des retour de brevo.
 * Les données affichées sont les suivantes:
 * - Email
 * - Type
 * - Raison
 * - Tag
 * - Date
 */
const apiPrefix = process.env.REACT_APP_API_PREFIX;

const BounceTable = () => {
    const [bounces, setBounces] = useState([]);
    const [loading, setLoading] = useState(true);

    const exportToExcel = async () => {
        const rows = bounces.map((b) => ({
            ID: b.id,
            Email: b.email,
            Type: b.event_type,
            Raison: b.reason ?? '',
            Tag: b.tag ?? '',
            'ID message': b.message_id ?? '',
            'IP envoi': b.sending_ip ?? '',
            'Template ID': b.template_id ?? '',
            Date: b.timestamp ? new Date(b.timestamp).toLocaleString('fr-FR') : '',
        }));
        const dateStr = new Date().toISOString().slice(0, 10);
        await downloadJsonAsExcel(rows, 'Bounces', `bounces_brevo_${dateStr}.xlsx`);
    };

    useEffect(() => {
        // Utilisation de fetch pour récupérer les bounces
        fetch(apiPrefix + `api/brevo/bounces`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                setBounces(data);
                setLoading(false);
                console.log(data);
            })
            .catch(error => {
                console.error('Error fetching bounces:', error);
                setLoading(false);
            });
    }, []);



    if (loading) {
        return (
            <div className="container-responsive section-padding">
                <div className="flex justify-center items-center min-h-[200px]">
                    <div className="loading-spinner"></div>
                    <span className="ml-3 text-gray-600">Chargement des bounces...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="container-responsive section-padding">
            <div className="max-w-7xl mx-auto">
                <div className="card mb-6">
                    <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between mb-4">
                        <h1 className="text-2xl font-bold text-primary">Gestion des bounces email</h1>
                        <button
                            type="button"
                            onClick={exportToExcel}
                            disabled={bounces.length === 0}
                            className="btn-secondary whitespace-nowrap self-start disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <i className="fas fa-file-excel mr-2" aria-hidden="true"></i>
                            Exporter en Excel
                        </button>
                    </div>
                    <div className="alert alert-info">
                        <i className="fas fa-info-circle mr-2"></i>
                        Il y a <strong>{bounces.length}</strong> e-mail(s) qui n'ont pas pu être livrés
                    </div>
                </div>

                <div className="card">
                    <div className="overflow-x-auto">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Email</th>
                                    <th>Type</th>
                                    <th>Raison</th>
                                    <th>Tag</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bounces.map(bounce => (
                                    <tr key={bounce.id}>
                                        <td className="font-medium">{bounce.email}</td>
                                        <td>
                                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                                bounce.event_type === 'bounce' 
                                                    ? 'bg-red-100 text-red-800' 
                                                    : 'bg-yellow-100 text-yellow-800'
                                            }`}>
                                                {bounce.event_type}
                                            </span>
                                        </td>
                                        <td className="text-gray-600">{bounce.reason}</td>
                                        <td>
                                            {bounce.tag && (
                                                <span className="px-2 py-1 bg-gray-100 text-gray-800 rounded text-xs">
                                                    {bounce.tag}
                                                </span>
                                            )}
                                        </td>
                                        <td className="text-gray-500 text-sm">
                                            {new Date(bounce.timestamp).toLocaleString()}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BounceTable;
